import React, { useLayoutEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useAffirmProvider } from '../AffirmNewTest/AffirmProvider'
import isEqual from 'lodash/isEqual'

interface PriceInsertProps {
  price: number
  planCode: string
}

export const Affirm: React.FC<PriceInsertProps> = ({ price, planCode }) => {
  const { classes, cx } = useStyles()
  const { refreshAffirm } = useAffirmProvider()

  useLayoutEffect(() => {
    refreshAffirm()
  }, [price, planCode])

  return (
    <Box minHeight="25px">
      <Typography
        className={cx(classes.originalPrice, 'affirm-as-low-as')}
        data-page-type="product"
        data-amount={price * 100}
        data-learnmore-show="false"
        data-sku={planCode}
      />
    </Box>
  )
}

const useStyles = makeStyles()({
  originalPrice: {
    fontSize: '.875rem',
    margin: '0',
    '& a': {
      textDecoration: 'none',
      color: 'inherit',
      /* eslint-disable @typescript-eslint/no-var-requires, @typescript-eslint/naming-convention */
      '& .__affirm-logo.__affirm-logo-primary, .__affirm-logo.__affirm-logo-blue':
        {
          color: 'inherit',
        },
    },
  },
})

export default React.memo(Affirm, isEqual)
